<template>
    <div class="threejsContainer">
      <div class="containerTitle">1-16.透视和正交相机机混合渲染2(单场景、单渲染、双相机)</div>
      <div ref="container" class="containerBody"></div>
    </div>
  </template>
  
  <script>
  import * as THREE from 'three';
  import {generateScene} from '@/threejsEnv/scene.js';
  import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
  import {genPerspectiveCamera,genOrthographicCamera} from '@/threejsEnv/camera.js';
  import {genRenderer} from '@/threejsEnv/renderer.js';
  
  export default {
    data() {
      return {
        scene: null,
        camera1: null,
        camera2: null,
        renderer: null,
        controls: null,
        cube: null,
        u_time: 0,
        window: {
          width: 0,
          height: 0
        },
        animationId: null
      };
    },
    mounted() {
      //初始化环境
      this.initEnv();
      //创建网格对象
      this.createMesh();
      this.animate();

      const scale = 8;
      this.camera2.left *= scale;
      this.camera2.right *= scale;
      this.camera2.top *= scale;
      this.camera2.bottom *= scale;
        this.camera2.position.x = -50;
        this.camera2.position.y = 10;
        this.camera2.position.z = 18;


      // 必须更新投影矩阵
      this.camera2.updateProjectionMatrix();

      // 监听窗口大小变化
      window.addEventListener('resize', this.onWindowResize);
    },
    methods: {
      createMesh() {
        const material = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: false });
        const geometry = new THREE.BoxGeometry();
        this.cube = new THREE.Mesh(geometry, material);
        this.scene.add(this.cube);
      },
      animate() {
        this.u_time += 0.02;
        this.cube.position.x = Math.sin(this.u_time)*5.0;
        this.animationId = requestAnimationFrame(this.animate);
        this.controls.update();
        this.renderer.setViewport( 0, 0, window.innerWidth, window.innerHeight );
        this.renderer.render(this.scene, this.camera1);
        
				this.renderer.clearDepth(); // important!
        
        this.renderer.setScissorTest( true );
        this.renderer.setScissor( window.innerWidth*4/5-10, this.window.height*2/3-10, this.window.width/5.0, this.window.height/3.0 );
				this.renderer.render( this.scene, this.camera2 );

				this.renderer.setScissorTest( false );
        this.camera2.lookAt(-50,0,18);
      },
      initEnv(){
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        // 初始化场景
        this.scene = generateScene();
        this.scene.background = new THREE.Color(0xffffff);
  
        // 初始化相机
        this.camera1 = genPerspectiveCamera(this.window);
  
        // 初始化相机
        this.camera2 = genOrthographicCamera(this.window);

        // 初始化渲染器
        this.renderer = genRenderer(this.window);
        this.$refs.container.appendChild(this.renderer.domElement);
  
        // 添加轨道控制器
        this.controls = new OrbitControls(this.camera1, this.renderer.domElement);
        this.controls.enableDamping = true;
  
        // 创建光源
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);
        
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(10, 20, 15);
        this.scene.add(directionalLight);
  
        const gridHelper = new THREE.GridHelper(100, 100,
                                                0x666666,   // 中心轴线颜色（红色）
                                                0xcccccc    // 普通网格线颜色（绿色）
                                                ); // 10x10 网格
        this.scene.add(gridHelper);
      },
      onWindowResize() {
        const width = this.$refs.container.clientWidth;
        const height = this.$refs.container.clientHeight;
  
        // 更新相机
        this.camera1.aspect = width / height;
        this.camera1.updateProjectionMatrix();
  
        // 更新渲染器
        this.renderer.setSize(width, height);
      }
    },
    beforeDestroy() {
      // 清理动画和事件监听
      cancelAnimationFrame(this.animationId);
      window.removeEventListener('resize', this.onWindowResize);
      
      this.controls.dispose();
      this.renderer.dispose();
      this.renderer.domElement.remove();
    }
  };
  </script>
  
  <style>
  </style>
  